import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import CommonUsualText from '../../../common-components/common-usual-text';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

let list = [
    {
        img: '/images/svg/converter/converter-complex__item-img1.svg',
        title: 'Перед нами поставили 6 масштабных задач',
        subtitle: `<ul class="common__ol-list letovo-tasks-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style="color: #0cc0dd">1.</span>
                            <span class="common__ol-info">Редизайн сайта</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style="color: #0cc0dd">2.</span>
                            <span class="common__ol-info">Перенос сайта на&nbsp;CMS</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style="color: #0cc0dd">3.</span>
                            <span class="common__ol-info">Внедрение интеграций в&nbsp;рамках развития и&nbsp;информационной поддержки сайта</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style="color: #0cc0dd">4.</span>
                            <span class="common__ol-info">Модернизация личного кабинета</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style="color: #0cc0dd">5.</span>
                            <span class="common__ol-info">Разработка серии инфографиков и&nbsp;презентаций о&nbsp;ключевых направлениях работы Фонда</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style="color: #0cc0dd">6.</span>
                            <span class="common__ol-info">Техподдержка</span>
                        </li>
                    </ul>
`,
        reverse: false,
    },
];

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} className="letovo-tasks">
                <CommonTitle>Задачи</CommonTitle>

                <CommonUsualText className="letovo-tasks__title">
                    В&nbsp;2017 году мы&nbsp;получили функционирующий школы Летово, который нужно
                    было развивать дальше, чтобы он&nbsp;вместе со&nbsp;школой соответствовал всем
                    современным тенденциям, совершенствовался и&nbsp;становился только удобнее для
                    абитуриентов, учащихся, их&nbsp;родителей и&nbsp;самого клиента.
                </CommonUsualText>

                <div className="letovo-tasks__container">
                    {list.map(({ img, title, subtitle, reverse }, index) => (
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className={
                                reverse
                                    ? 'letovo-tasks__item letovo-tasks__item--reverse'
                                    : 'letovo-tasks__item'
                            }
                            key={index}
                        >
                            <div className="letovo-tasks__item-img">
                                <img src={img} alt="" loading="lazy" />
                            </div>
                            <div className="letovo-tasks__item-info">
                                <CommonSmallTitle className="letovo-tasks__item-title">
                                    {parse(title)}
                                </CommonSmallTitle>
                                {parse(subtitle)}
                            </div>
                        </ScrollAnimation>
                    ))}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
